<div id="login_modal_header" class="login-modal-header">
  <idp-logo-header
    [logoUrl]="loginHeaderContent?.logoUrl"
    [altText]="loginHeaderContent?.altText"
    [machCore]="machCore"
    (triggerClose)="triggerClose.emit()"
  ></idp-logo-header>
  <div class="row mx-0">
    <h1 class="login-modal-header__header-title">
      {{ loginHeaderContent?.headerTitle }}
    </h1>
  </div>
  <div *ngIf="checkOutWarmState && loginHeaderContent?.enterPasswordText">
    <h1 class="login-modal-header__header-password-text">
      {{ loginHeaderContent?.enterPasswordText }}
    </h1>
  </div>
  <div
    class="login-modal-header__fields-required-text"
    [ngClass]="{
      'remove-margin-bottom':
        loginHeaderContent?.contentBodyHeader !== undefined
    }"
    aria-live="polite"
  >
    {{ loginHeaderContent?.headerSubTitle }}
  </div>
  <div
    *ngIf="loginHeaderContent?.contentBodyHeader"
    class="login-modal-header__content-body-header"
  >
    {{ loginHeaderContent?.contentBodyHeader }}
  </div>
</div>
